import { useEffect, useState } from "react";
import { uiText } from "@/data/uiText";
import { tField } from "@/lib/i18nField";

const SCROLL_TOP_THRESHOLD = 360;

export default function ScrollTopButton({ lang }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function updateVisibility() {
      setIsVisible(window.scrollY > SCROLL_TOP_THRESHOLD);
    }

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    return () => window.removeEventListener("scroll", updateVisibility);
  }, []);

  function scrollToTop() {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
  }

  return (
    <button
      type="button"
      className={["tgwe-scroll-top", isVisible ? "is-visible" : ""].filter(Boolean).join(" ")}
      onClick={scrollToTop}
      aria-label={tField(uiText.scrollToTop, lang)}
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
    >
      ↑
    </button>
  );
}
